/* Co-Brand page: method explorer (tabs) and hotspot explorer. No dependencies. */
(() => {
  const select = (root, id) => {
    root.querySelectorAll('[data-cb-tab]').forEach((t) => {
      const on = t.dataset.cbTab === id;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      if (t.dataset.cbMarker !== undefined) t.classList.toggle('is-on', on);
    });
    root.querySelectorAll('[data-cb-panel]').forEach((p) => { p.hidden = p.dataset.cbPanel !== id; });
  };
  document.querySelectorAll('[data-cb-explorer]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-cb-tab]')];
    if (!tabs.length) return;
    tabs.forEach((t) => {
      t.addEventListener('click', () => select(root, t.dataset.cbTab));
      t.addEventListener('keydown', (e) => {
        const i = tabs.indexOf(t);
        let n = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') n = tabs[0];
        else if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); n.focus(); select(root, n.dataset.cbTab); }
      });
    });
    select(root, tabs[0].dataset.cbTab);
  });
})();
